// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"de70703d","84":"776abacb","236":"b1442f19","324":"4212d6b4","437":"5795e1eb","453":"522fe07f","554":"43bc723e","585":"34224d6a","625":"5b6c97ac","957":"2637d9ae","995":"39af194f"}[chunkId] + ".chunk.js";
};